import { Component, HostListener, OnInit } from '@angular/core';
import { ServiceUtils } from '../service/service-globals';
import { AccountDetailsService } from '../service/account-details/account.details.service';
import { AuthUserService } from '../service/auth-user-service';

@Component({
  selector: 'sam-frontend-admin-components',
  templateUrl: 'components.component.html',
  standalone: false,
})
export class ComponentsComponent implements OnInit {
  isMobileResolution: boolean = false;
  _document: any = document;
  userData: any;
  showUserDetailsUpdate: boolean = false;
  departmentName: any;
  subTierValue: any;

  constructor(
    public serviceUtils: ServiceUtils,
    private acctDetailsService: AccountDetailsService,
    public authService: AuthUserService,
  ) {}

  ngOnInit() {
    sessionStorage.removeItem('lastVisitedRoute');
    sessionStorage.removeItem('lastVisitedRouteFromChild');
    this.toggleResolution();
    this.serviceUtils.updateUserDetails.subscribe((userData) => {
      this.userData = userData;
      this.showUserDetailsUpdate = true;
    });
    this.acctDetailsService?.orgDataUpdate?.subscribe((orgData: any) => {
      this.serviceUtils.orgData = orgData;
    });
  }

  accountDetailsUpdate(data) {
    this.serviceUtils.updateAccountDetails.emit(data);
    this.showUserDetailsUpdate = false;
  }

  @HostListener('window:resize')
  onResize() {
    this.toggleResolution();
  }

  /**
   * @name toggleResolution
   * @description Sets isMobileResolution flag on page load and resize.
   *              Called by ngInit() and HostListener(window:resize)
   */
  private toggleResolution() {
    this.isMobileResolution = window.innerWidth <= 768;
  }

  /**
   * @name naviagteTo
   * @type Event - handles click event from html buttons
   * @param url : url to be routed to
   * DO NOT TEST. WINDOW.LOCATION.HREF WILL FORCE A BROWSER REFRESH WHICH DISRUPTS TESTING
   */
  navigateTo(url: string) {
    if (url === '/workspace') {
      window.location.href = location.protocol + '//' + location.hostname + url;
    }
  }

  hideProfileNav(document) {
    return (
      !document.getElementsByTagName('sam-frontend-admin-request-feeds')[0] &&
      !document.getElementsByTagName('sam-frontend-admin-requestor-side')[0] &&
      !document.getElementsByTagName('sam-frontend-admin-notification-feeds')[0]
    );
  }

  hideUserHeader(document) {
    return (
      !document.getElementsByTagName('sam-frontend-admin-request-feeds')[0] &&
      !document.getElementsByTagName('sam-frontend-admin-requestor-side')[0] &&
      !document.getElementsByTagName('sam-frontend-admin-notification-feeds')[0]
    );
  }

  showFeedsNav(document) {
    return (
      this.isMobileResolution ||
      document.getElementsByTagName('sam-frontend-admin-request-feeds')[0] ||
      document.getElementsByTagName('sam-frontend-admin-requestor-side')[0] ||
      document.getElementsByTagName('sam-frontend-admin-notification-feeds')[0]
    );
  }
}
